import { css, keyframes } from '@emotion/react';
import { IconButton, Icons, styled, useColorScheme } from '@healthinal/ui';

export function SwitchModeButton() {
  const { mode, setMode } = useColorScheme();

  return (
    <IconButton
      sx={{ display: 'grid', overflow: 'hidden', '&:active > *, &:focus > *': { '--animation-enabled': 1 } }}
      variant="plain"
      onClick={() => setMode(mode === 'dark' ? 'light' : 'dark')}>
      <LightModeIcon show={mode === 'light'} />
      <DarkModeIcon show={mode === 'dark'} />
    </IconButton>
  );
}

const iconCSS = css`
  grid-column: 1;
  grid-row: 1;
  transform-origin: center 45px;
  --animation-enabled: 0;
`;
const enter = keyframes`
  from {
    transform: rotate(0.125turn);
    opacity: 0;
  }
  to {
    transform: rotate(0turn);
    opacity: 1;
  }
`;
const exit = keyframes`
  from {
    transform: rotate(0turn);
    opacity: 1;
  }
  to {
    transform: rotate(-0.125turn);
    opacity: 0;
  }
`;
const LightModeIcon = styled(Icons.LightMode, { shouldForwardProp: (propName) => propName !== 'show' })<{
  show: boolean;
}>`
  ${iconCSS};
  animation: ${({ show }) => (show ? enter : exit)} forwards;
  animation-duration: calc(var(--animation-enabled) * ${({ show }) => (show ? 0.2 : 0.13)}s);
  animation-timing-function: ${({ show }) =>
    show ? 'cubic-bezier(0.4, 0, 0.61, 1.38)' : 'cubic-bezier(0.4, 0, 1, 1)'};
`;
const DarkModeIcon = styled(Icons.DarkMode, { shouldForwardProp: (propName) => propName !== 'show' })<{
  show: boolean;
}>`
  ${iconCSS};
  animation: ${({ show }) => (show ? enter : exit)} forwards;
  animation-duration: calc(var(--animation-enabled) * ${({ show }) => (show ? 0.2 : 0.13)}s);
  animation-timing-function: ${({ show }) =>
    show ? 'cubic-bezier(0.4, 0, 0.61, 1.38)' : 'cubic-bezier(0.4, 0, 1, 1)'};
`;
